export default "__VITE_ASSET__c445d40e__"